module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "registry"
  }, [_c('acHead'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "con-wrap"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('acFoot')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1696a7c0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/account/components/Wrap.vue
// module id = 1181
// module chunks = 2